export default __webpack_public_path__ + "static/media/first-bet-ico.f197077b.svg";